// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"bb3017e7","71":"3f5694fd","144":"3766e81f","352":"36e415c4","494":"e11598c6","528":"8c72e7f7","603":"92729632","982":"82f1d99b"}[chunkId] + ".chunk.js";
};